import { bindingCollection } from 'gl-commonui';
import "../service/binds";

bindingCollection.bindingToSyntax()